import { VisitItem } from "../../../api/medcard.types";
import { MedcardVisitsAllAction } from "./medcard.visits.all.types";

export const medcardVisitsAllRequestAction = (): MedcardVisitsAllAction => ({ type: 'MEDCARD_VISITS_ALL_REQUEST' })
export const medcardVisitsAllSuccessAction = (visits: VisitItem[]): MedcardVisitsAllAction => ({ type: 'MEDCARD_VISITS_ALL_SUCCESS', params: visits })
export const medcardVisitsAllFailureAction = (error?: any): MedcardVisitsAllAction => ({ type: 'MEDCARD_VISITS_ALL_FAILURE', params: error })